<template>
	<div>
		<!-- If modal have a "pui-select" or "pui-date-field", set property :overflow="false" -->
		<!-- If fixed width is needed, set property :widthDialog="XXX" -->
		<pui-modal-dialog-form :titleText="$t('modal.agenteaduana.sample.title')" :modelName="modelName"
			:dialogName="agenteaduanaSampleModal" :onOk="onOkSampleModal" :onShow="onShowSampleModal">
			<template slot="message" slot-scope="data">
				<v-layout row wrap>
					<!-- NIFAGENTEADUANA -->
					<v-flex xs4 md2>
						<pui-text-field :id="`nifagenteaduana-agenteaduana`" v-model="data.modalData.nifagenteaduana"
							:label="$t('agenteaduana.nifagenteaduana')" :disabled="formDisabled" required toplabel
							maxlength="17"></pui-text-field>
					</v-flex>
				</v-layout>
			</template>
		</pui-modal-dialog-form>
	</div>
</template>

<script>
export default {
	name: 'agenteaduana-modals',
	data() {
		return {
			agenteaduanaSampleModal: 'agenteaduanaSampleAction'
		};
	},
	props: {
		modelName: {
			required: true,
			type: String
		}
	},
	methods: {
		onOkSampleModal(modalData) {
			const params = {
				attr1: modalData.field1
			};

			const url = this.$store.getters.getModelByName(this.modelName).url.sampleUrl;
			var title = this.$puiI18n.t('puiaction.notifyTitle') + ' > ' + this.$puiI18n.t('modal.agenteaduana.sampleaction.title');
			return new Promise(resolve => {
				this.$puiRequests.postRequest(
					url,
					null,
					response => {
						// Valid response, do code and close modal
						console.log(response);
						resolve(true);
					},
					e => {
						// Error response, do code and not close modal
						let message = this.$puiI18n.t('puiaction.notifyError');
						if (e.response && e.response.data) {
							message = e.response.data.message;
						}
						this.$puiEvents.$emit('onPui-action-running-ended-' + this.modelName);
						this.$puiNotify.error(message, title);
						resolve(false);
					},
					null,
					params
				);
			});
		},
		onShowSampleModal(modalData) {
			// Put here code to execute before open modal.
			// Examples:
			// - Watch pui-select/pui-datatable with events
			// - change values or set new values "this.$set(modalData,'field3', null)"
			// ...
			console.log(modalData);
		}
	}
};
</script>
